import { fetchWrapper, handleResponse, buildOpts, hcUrl } from '../helpers';

export const getHomePreviousBaskets = async () => {
  const response = await fetchWrapper(hcUrl('/home/previous_baskets'), buildOpts());
  return handleResponse(response);
};
